import script from "./AddTeamMemberButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeamMemberButton.vue?vue&type=script&setup=true&lang=js"

import "./AddTeamMemberButton.vue?vue&type=style&index=0&id=584cdac6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584cdac6"]])

export default __exports__